import { MenuItem } from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import InputFormat from "../../partials/inputForm";
import SelectMultipleFormat from "../../partials/selectMultiForm";
import { styles } from "./styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class SelectedBranch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  handleChange = (event) => {
    let branch = event.target.value;
    this.props.handleChangeBranch(branch);
  };
  componentDidMount = () => {
    this.props.onRef(this);
    this.props.serviceBranchDispatch.getListBranch();
  };
  getBranchName = (branchCode) => {
    // call from parent component
    let listBranch = this.props.listBranch;
    if (Array.isArray(listBranch)) {
      let filter = listBranch.find((e) => e.branchCode === branchCode);
      return filter ? filter.branchName : "";
    }
  };
  render() {
    const { classes, disabled, required, t, multiple, name } = this.props;
    let listBranch = this.props.listBranch;
    if (multiple) {
      const { value = [] } = this.props;
      return (
        <div className={classes.root}>
          <SelectMultipleFormat
            multiple={multiple}
            disabled={disabled}
            required={required}
            variant="outlined"
            label={t("selectebranchwithmap_branch")}
            name={name}
            value={value}
            onChange={this.handleChange}
            fullWidth={true}
            list={listBranch.map((e) => {
              return {
                value: e.branchCode,
                label: e.branchName,
              };
            })}
          />
        </div>
      );
    } else {
      const { value = "" } = this.props;
      return (
        <div className={classes.root}>
          <InputFormat
            select
            disabled={disabled}
            required={required}
            variant="outlined"
            label={t("selectebranchwithmap_branch")}
            value={value}
            onChange={this.handleChange}
            fullWidth={true}
          >
            {listBranch.map((branch, i) => {
              return (
                <MenuItem
                  key={`${branch.branchCode}-${i}`}
                  value={branch.branchCode}
                >
                  {branch.branchName}
                </MenuItem>
              );
            })}
          </InputFormat>
        </div>
      );
    }
  }
}

SelectedBranch.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceBranch: state.serviceBranch,
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({
  serviceBranchDispatch: dispatch.serviceBranch,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SelectedBranch)
  )
);
